module.exports = __webpack_public_path__ + "img/user-guide-02-02-01.9c4f406e.png";